export const summaries = [
  { id: 1, title: "Section 1", description: "In a historic moment..." },
  { id: 2, title: "Section 2", description: "SpaceX, the private..." },
  { id: 3, title: "Section 3", description: "This mission marks..." },
  { id: 4, title: "Section 4", description: "Elon Musk, SpaceX's CEO..." },
  { id: 5, title: "Section 5", description: "As the Starship embarks..." },
  { id: 6, title: "Section 6", description: "This mission marks..." },
  { id: 7, title: "Section 7", description: "Stay tuned for updates..." },
];

export const STORAGE_KEYS = {
  LOCAL_STORAGE: "access_token",
  USER: "user",
  SUB: "subscribed",
};

export const HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const SESSIONS_MAP = {
  instant: "Live Audio Recording",
  file: "Uploaded Audio File",
  video: "Recorded Video Session",
};

export const STATUS_MAP = {
  active: {
    label: "Active",
    color: "text-green-400",
    bgColor: "bg-green-400/10",
    borderColor: "border-green-400/30",
  },
  in_active: {
    label: "Inactive",
    color: "text-gray-400",
    bgColor: "bg-gray-400/10",
    borderColor: "border-gray-400/30",
  },
  in_progress: {
    label: "Recording",
    color: "text-red-400",
    bgColor: "bg-red-400/10",
    borderColor: "border-red-400/30",
    animated: true,
  },
  preprocessing: {
    label: "Pre-processing",
    color: "text-yellow-400",
    bgColor: "bg-yellow-400/10",
    borderColor: "border-yellow-400/30",
  },
  processing: {
    label: "Processing",
    color: "text-blue-400",
    bgColor: "bg-blue-400/10",
    borderColor: "border-blue-400/30",
  },
  completed: {
    label: "Completed",
    color: "text-primary",
    bgColor: "bg-primary/10",
    borderColor: "border-primary/30",
  },
};

export const CONTENT_TEST = "";

export const USAGE_CARD = {
  totalTokensUsed: "",
  lastUsed: "",
  featureUsage: [],
};

export const initialSubscriptionDetails = {
  plan: "free",
  status: "",
  startDate: "",
  endDate: "",
  lastPaymentDate: "",
  autoRenew: false,
};
